import React from "react";

export interface DeleteModalProps {
  title: string;
  description: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteModal: React.FC<DeleteModalProps> = ({
  title,
  description,
  confirmLabel,
  onConfirm,
  onCancel,
}) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
    <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-sm mx-4">
      <div className="flex items-start justify-between mb-3">
        <h3 className="text-base font-semibold text-gray-900">{title}</h3>
        <button onClick={onCancel} className="text-[#7B7B7B] font-semibold hover:text-gray-600 ml-4">
          <svg viewBox="0 0 24 24" className="w-4 h-4 fill-none stroke-current stroke-2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <p className="text-sm text-gray-500 mb-5">{description}</p>
      <div className="flex justify-end gap-2">
        <button
          onClick={onCancel}
          className="px-4 py-2 text-sm border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className="px-4 py-2 text-sm bg-red-500 hover:bg-red-600 text-white rounded-lg font-medium transition-colors"
        >
          {confirmLabel}
        </button>
      </div>
    </div>
  </div>
);